// extracted by mini-css-extract-plugin
module.exports = {"cookies-notification-banner":"cookie-notification_cookies-notification-banner__3QHJ4","cookies-button-wrapper":"cookie-notification_cookies-button-wrapper__3vxwd"};